import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { ClientFaqResource } from 'app/models/ClientFaqResource';
import { UtilsService } from 'app/services/utils.service';
import { forkJoin } from 'rxjs';
import { KioskListResource } from 'app/models/KioskListResource';
import { KioskResource } from 'app/models/KioskResource';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { FilterCriteriaEDT } from 'app/models/FilterCriteriaEDT';
import { ClientFaqAndKioskResource } from 'app/models/ClientFaqAndKioskResource';

@Component({
  selector: 'vbn-add-edit-faq',
  templateUrl: './add-edit-faq.component.html',
  styleUrls: ['./add-edit-faq.component.scss']
})
export class AddEditFaqComponent implements OnInit {

  selected_language: string;
  faq: ClientFaqResource;
  faqRid: any;
  addressParams: any;
  errorMessage: any;
  userEmail: string;
  validationForm: FormGroup;
  saveErrors: boolean = false;

  kiosksList: KioskListResource;
  filterCriteria: FilterCriteriaListEdt;
  checkList: any;
  checkObject: any;
  kioskListResource: KioskResource[];
  arrayToSend: any;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: UtilsService,
    private translate: TranslateService,
    private fb: FormBuilder,
    private _notificationService: NotificationsService) {

    this.selected_language = "ro";
    this.faq = new ClientFaqResource();

    this.kiosksList = new KioskListResource();
    this.kiosksList.list = new Array<KioskResource>();
    this.filterCriteria = new FilterCriteriaListEdt();
    this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
    this.checkList = new Array();
    this.kioskListResource = new Array();
    this.arrayToSend = new Array();

  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getKioskList();
    if (this.router.url != '/add-client-faq') {
      this.activatedRoute.params.subscribe((params: Params) => {
        if ('json' in params) {
          this.addressParams = JSON.parse(atob(params['json']));
          this.faqRid = this.addressParams.faqRid;
          this.getFaqByRid(this.faqRid);
        }
      });
    }

    this.validationForm = this.fb.group({
      questionRo: ['', [Validators.required, Validators.maxLength(150), Validators.minLength(3)]],
      questionEn: [''],
      questionFr: [''],
      questionDe: [''],

      answerRo: ['', [Validators.required, Validators.minLength(3)]],
      answerEn: [''],
      answerFr: [''],
      answerDe: [''],
    })
  }

  updateCheckedOptionsKiosk(kiosk, event) {
    if (event.target.checked) {
      let termsOrGdpr = new ClientFaqAndKioskResource()
      termsOrGdpr.kiosk = kiosk;
      this.arrayToSend.push(termsOrGdpr);
    } else {
      for (let i = 0; i < this.arrayToSend.length; i++) {
        if (kiosk.rid == this.arrayToSend[i].kiosk.rid) {
          this.arrayToSend.splice(i, 1);
          return
        }
      }
    }
  }

  getFaqByRid(rid) {
    this.service.get(`/admin/clientFaq/getOne/${rid}?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          this.faq = response;
          Object.assign(this.kioskListResource, this.kiosksList)
          for (let i = 0; i < this.kioskListResource.length; i++) {
            for (let j = 0; j < this.faq.kioskResourceList.length; j++) {
              if (this.faq.kioskResourceList[j].kiosk.rid == this.kioskListResource[i].rid) {
                for (let k = 0; k < this.checkList.length; k++) {
                  if (this.checkList[k].kiosk.rid == this.kioskListResource[i].rid) {
                    this.checkList[k].check = true;
                    this.arrayToSend.push(this.checkList[k]);
                  }
                }
              }
            }
          }
          if ([11154, 11150, 11157].indexOf(this.faq.errorCode) > 0) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`Get faq info error - (${response.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          }
        },
        error => this.errorMessage = <any>error);
  }

  getKioskList() {
    this.service.add('/admin/kiosk/getAll?userEmail=' + this.userEmail, this.filterCriteria)
      .subscribe(
        response => {
          this.kiosksList = response;
          if (this.kiosksList.errorCode == 1002) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get('0 items found after the search!')]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            });
            this.kiosksList = new KioskListResource();
            this.filterCriteria.filters = new Array<FilterCriteriaEDT>();
            this.kiosksList.list = [];
          }
          this.initializationKioskList();
        },
        error => this.errorMessage = <any>error);
  }

  initializationKioskList() {
    if (this.kiosksList.list == null) {
      this.kioskListResource = []
    } else {
      this.kioskListResource = this.kiosksList.list;
    }
    this.checkList = new Array();
    for (let i = 0; i < this.kiosksList.list.length; i++) {
      this.checkObject = {};
      this.checkObject.kiosk = new ClientFaqAndKioskResource();
      this.checkObject.kiosk = this.kiosksList.list[i];
      this.checkList.push(this.checkObject);
    }
    this.checkObject = {};
  }

  edit() {
    this.saveErrors = true;
    let errors = false;
    if (!this.validationForm.valid) {
      forkJoin(
        [this.translate.get('Error'),
        this.translate.get(`Required fields`)]
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
      errors = true;
    }
    if (this.arrayToSend.length == 0) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please check at least 1 kiosk!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      errors = true;
    }
    if(errors) {
      return;
    }
    (!this.faqRid) && (this.faq.userEmail = this.userEmail);
    this.faq.kioskResourceList = this.arrayToSend;
    this.service.add('/admin/clientFaq/edit', this.faq)
      .subscribe(
        response => {
          this.faq = response;
          if (this.faq.errorCode === 11151) {
            forkJoin(
              [this.translate.get('Error'),
              this.translate.get(`Add question in all languages - (${this.faq.errorCode})`)]
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'error')
            })
          } else {
            if (this.faq.errorCode === 11153) {
              forkJoin(
                [this.translate.get('Error'),
                this.translate.get(`Add faq - Unknown user - (${this.faq.errorCode})`)]
              ).subscribe((res) => {
                this._notificationService.create(res[0], res[1], 'error')
              })
            } else {
              if (this.faq.errorCode === 11154 || this.faq.errorCode === 11155) {
                forkJoin(
                  [this.translate.get('Error'),
                  this.translate.get(`Add faq error - (${this.faq.errorCode})`)]
                ).subscribe((res) => {
                  this._notificationService.create(res[0], res[1], 'error')
                })
              } else {
                if (this.faqRid) {
                  forkJoin(
                    [this.translate.get('Success'),
                    this.translate.get('Faq was successfully edited!')]
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'success')
                  });
                } else {
                  forkJoin(
                    [this.translate.get('Success'),
                    this.translate.get('Faq was successfully created!')]
                  ).subscribe((res) => {
                    this._notificationService.create(res[0], res[1], 'success')
                  });
                }
                this.router.navigate(['/faq']);
              }
            }
          }


        },
        error => this.errorMessage = <any>error);
  }

  showResponsiveDetails(kioskId) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.kiosksList.list.length; i++) {
        if (this.kiosksList.list[i].rid == kioskId) {
          this.kiosksList.list[i].showDetailsOnResponsive = !this.kiosksList.list[i].showDetailsOnResponsive;
        }
        else {
          this.kiosksList.list[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }

}
